export enum ImportedBy {
    None = 0,
    Pi = 1,
    UpdatedPi = 2,
    IndentifiedPi = 3,
}
